import request from '@/utils/request'

// 上传附件
export const uploadFile = (postData) => {
  return request({
    url: '/file/upload',
    method: 'post',
    headers: {
      'content-type': 'multipart/form-data'
    },
    data: postData
  })
}
// 获取项目列表
export const getProjecitList = (postData) => {
  return request({
    url: '/inspect-contract/getProjecitList',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 获取合同
export const getContractList = (postData) => {
  return request({
    url: '/inspect-contract/getContractList',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 获取图表数据接口横向柱状
export const queryScoreByLevelThird = (postData) => {
  return request({
    url: '/inspectAnalystReports/queryScoreByLevelThird',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 获取图表数据接口柱状
export const dangerousDeviceByType = (postData) => {
  return request({
    url: '/inspectAnalystReports/dangerousDeviceByType',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 生成检查分析报告
export const genReports = (postData) => {
  return request({
    url: '/inspectAnalystReports/genReports',
    method: 'post',
    headers: {
      'content-type': 'application/json;charset = utf-8'
    },
    data: postData
  })
}
// 获取项目的开始/结束时间
export const findTime = (postData) => {
  return request({
    url: '/inspectAnalystReports/findContractIdStartTimeAndEndTime',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 获取项目的开始/结束时间
export const findApplyStatus = (postData) => {
  return request({
    url: '/inspectAnalystReports/findApplyStatus',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 生成检测分析报告
export const genCheckReports = (postData) => {
  return request({
    url: '/checkAnalystReports/genReports  ',
    method: 'post',
    headers: {
      'content-type': 'application/json;charset = utf-8'
    },
    data: postData
  })
}
